import React, { useContext, useEffect } from 'react';
import { Widget, usePromise, Table, CrudContext, useRouter } from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getHistorico, HistoricoControleQaqc } from '@app/api/controleQaqc';

const columns = [
  {
    title: 'Responsável',
    dataIndex: 'usuarioResponsavel',
    key: 'usuarioResponsavel',
    width: '15%',
  },
  {
    title: 'Descrição',
    dataIndex: 'descricao',
    key: 'descricao',
    width: '30%',
  },
  {
    title: 'Data / Hora',
    dataIndex: 'dataHoraFormatada',
    key: 'dataHoraFormatada',
    width: '15%',
  },
  {
    title: 'Status Anterior',
    dataIndex: 'statusAnteriorNome',
    key: 'statusAnteriorNome',
    width: '20%',
  },
  {
    title: 'Novo Status',
    dataIndex: 'statusAtualNome',
    key: 'statusAtualNome',
    width: '20%',
  },
];

interface Props {
  id: string;
  update: boolean;
}

const AbaHistorico = (props: Props) => {
  const { id, update } = props;

  const [data] = usePromise(
    () => (id ? getHistorico(id) : Promise.resolve(undefined)),
    [id, update],
    [] as HistoricoControleQaqc[],
  );

  return (
    <>
      <Widget title="Histórico">
        <PerfectScrollbar>
          <Table columns={columns} rowKey="index" dataSource={data} pagination={false} />
        </PerfectScrollbar>
      </Widget>
    </>
  );
};

export default AbaHistorico;
